var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderMailTag',{attrs:{"custom-customer-props":_vm.senderProps}})
}
var staticRenderFns = []

export { render, staticRenderFns }